import { YoutubeEmbedded } from '@/components/shared-components/YoutubeEmbedded'
import { VideoDisplayBlock as VideoDisplayBlockType } from '@/modules/templates/types/blueprint'

type Props = {
  block: VideoDisplayBlockType
}

export const VideoDisplayBlock: React.FC<Props> = ({ block }) => {
  return <YoutubeEmbedded url={block.url} caption={block.caption} />
}
